// eslint-disable-next-line no-unused-vars
import React, { createContext } from 'react'

export const OrgContext = createContext(null)

export const UserContext = createContext(null)

export const DrawerContext = createContext(null)
